import { styled } from "@mui/material"

import { TextField } from "@cirrus/ui-kit-ts/src/components/atoms/TextField"

export const TextFieldLogon = styled(TextField)({
	marginBottom: "16px",

	"& .MuiFormHelperText-root": {
		padding: "4px 16px",
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "16px",
		letterSpacing: 0,
	},
	"& .notranslate": {
		display: "none"
	},
	"& .MuiFilledInput-root": {
		// border: "1px dotted gray",
		minHeight: "48px",
	},
	"& .MuiFilledInput-root .MuiFilledInput-input": {
		letterSpacing: 0.5,
		fontSize: "1.6rem",
	},
})

export const TextFieldWithAbsoluteHelperText = styled(TextFieldLogon)({
	// TODO: Apply positioning on the root component level (?)

	"& .MuiFormHelperText-root": {
		position: "absolute",
		top: "45px",
	}
})
